
import Vue from 'vue';
import gql from 'graphql-tag';
import AppHeader from '@/components/AppHeader.vue';
import IconButton from '@/components/IconButton.vue';
import { reportList, reportRemove } from '@/sync/ReportDb';
import ReportItem from '@/components/ReportItem.vue';
import { apolloClient } from '@/apolloClient';
import { viewPdfReport } from '@/openReportUrl';
import LoadingOverlay from 'vue-loading-overlay';
import CredStore from '@/CredStore';
import { inspectList } from '@/sync/InspectDb';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      list: {
        reports: [],
        review: [],
      },
      inspectList: [],
      result: {},
      wait: false,
      welcomeValue: localStorage.getItem('app-welcome') !== 'hide',
    };
  },
  components: {
    AppHeader,
    IconButton,
    ReportItem,
    LoadingOverlay,
  },
  mounted() {
    this.$store.dispatch('clearReport');
    this.loadReportList();
  },
  methods: {
    edit(report) {
      this.$router.push('/report/' + report.uuid + '/section');
    },
    view(report) {
      viewPdfReport(report, 'std');
    },
    reject(report) {
      this.$router.push(`/report/${report.uuid}/reject`);
    },
    async accept(report) {
      if (confirm('Please confirm your review of this report')) {
        this.wait = true;
        apolloClient
          .mutate({
            mutation: gql`
              mutation approve($reportId: Uuid!) {
                FinaliseInspectReportReview(reportId: $reportId)
              }
            `,
            variables: { reportId: report.uuid },
          })
          .then(async () => {
            this.wait = false;
            await reportRemove(report.uuid);
            this.loadReportList();
          })
          .catch((e) => {
            this.wait = false;
            alert(`Error Approving Report ${e}`);
          });
      }
    },
    loadReportList() {
      reportList().then((list) => {
        this.list = {
          ...this.list,
          reports: list.sort((a, b) => a.title.localeCompare(b.title)),
        };
      });
      inspectList().then((list) => {
        this.inspectList = list;
      });
    },
  },
  computed: {
    myReports() {
      return this.list.reports.filter(
        (x) => parseInt(x.inreportstatus, 10) <= 2
      );
    },
    awaitingReview() {
      return this.list.reports.filter(
        (x) => parseInt(x.inreportstatus, 10) === 4 && x.toreview !== true
      );
    },
    awaitingReviewForReviewer() {
      return this.list.reports.filter(
        (x) => parseInt(x.inreportstatus, 10) === 4 && x.toreview === true
      );
    },
    none() {
      return (
        this.myReports.length === 0 &&
        this.awaitingReview.length === 0 &&
        this.awaitingReviewForReviewer.length === 0
      );
    },
    canCreate() {
      return CredStore.creator >= 8;
    },
    canSearch() {
      return CredStore.creator >= 4;
    },
    firstInspect() {
      const report = this.myReports[0];
      if (!report) {
        return null;
      }
      return this.inspectList.find((x) => x.uuid === report.inreporttype);
    },
    welcomeMessage() {
      if (this.firstInspect?.prop_inspectwelcome?.length > 10) {
        return this.firstInspect.prop_inspectwelcome;
      }
      return null;
    },
    welcomeShow: {
      get() {
        return this.welcomeValue;
      },
      set(v) {
        this.welcomeValue = v;
        localStorage.setItem('app-welcome', v ? 'show' : 'hide');
      },
    },
  },
});
